export enum Frequency {
    WHEN_POSSIBLE = 'WHEN_POSSIBLE',
    ONCE_A_WEEK = 'ONCE_A_WEEK',
    ONCE_EVERY_TWO_WEEKS = 'ONCE_EVERY_TWO_WEEKS',
    ONCE_EVERY_THREE_WEEKS = 'ONCE_EVERY_THREE_WEEKS',
    ONCE_A_MONTH = 'ONCE_A_MONTH',
}
